"use strict";

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); //================================================================ 

/** @module std.experimental */
//================================================================

var ConditionVariable_1 = require("./ConditionVariable");
/**
 * Flex Barrier for critical sections.
 *
 * The FlexBarrier class blocks critical sections until the downward counter to be zero. Unlike the {@link Barrier} class, FlexBarrier can re-define downward count size by custom function.
 *
 * @author Jeongho Nam <samchon@samchon.org>
 */


var FlexBarrier =
/** @class */
function () {
  /* ---------------------------------------------------------
      CONSTRUCTOR
  --------------------------------------------------------- */

  /**
   * Initializer Constructor.
   *
   * @param size Size of the downward counter.
   * @param complete Complete function re-configuring *size* when downward count be zero. Default is a function always returning -1, which means the barrier is not reusable more.
   */
  function FlexBarrier(size, complete) {
    if (complete === void 0) {
      complete = function complete() {
        return -1;
      };
    }

    this.cv_ = new ConditionVariable_1.ConditionVariable();
    this.complete_ = complete;
    this.size_ = size;
    this.count_ = 0;
  }
  /* ---------------------------------------------------------
      ARRIVES
  --------------------------------------------------------- */


  FlexBarrier.prototype.arrive = function (n) {
    if (n === void 0) {
      n = 1;
    }

    return __awaiter(this, void 0, void 0, function () {
      var completed;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            completed = (this.count_ += n) >= this.size_;
            if (completed === false) return [2
            /*return*/
            ];
            this.size_ = this.complete_();
            this.count_ %= this.size_;
            return [4
            /*yield*/
            , this.cv_.notify_all()];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  FlexBarrier.prototype.arrive_and_wait = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.arrive()];

          case 1:
            _a.sent();

            return [4
            /*yield*/
            , this.wait()];

          case 2:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  FlexBarrier.prototype.arrive_and_drop = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            --this.size_;
            return [4
            /*yield*/
            , this.arrive(0)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /* ---------------------------------------------------------
      WAIT FUNCTIONS
  --------------------------------------------------------- */


  FlexBarrier.prototype.wait = function () {
    return this.cv_.wait();
  };

  return FlexBarrier;
}();

exports.FlexBarrier = FlexBarrier;
exports.flex_barrier = FlexBarrier;